import { render, staticRenderFns } from "./FeedBackList.vue?vue&type=template&id=276fa5d0&scoped=true&"
import script from "./FeedBackList.vue?vue&type=script&lang=js&"
export * from "./FeedBackList.vue?vue&type=script&lang=js&"
import style0 from "./FeedBackList.vue?vue&type=style&index=0&id=276fa5d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276fa5d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('276fa5d0')) {
      api.createRecord('276fa5d0', component.options)
    } else {
      api.reload('276fa5d0', component.options)
    }
    module.hot.accept("./FeedBackList.vue?vue&type=template&id=276fa5d0&scoped=true&", function () {
      api.rerender('276fa5d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/basic/report/FeedBackList.vue"
export default component.exports